export default {_name:'bluetooth.peripheral',module:'Field',view:'Element/Bluetooth/Peripheral',options:{key:'bluetoothPeripheral',xs:'auto',ms:'auto'}}